import taxCertificateEditPage from './view/edit_taxCertificate.html'
import taxCertificatePage from './view/taxCertificate.html'

// 纳税人管理
export const taxCertificateRouter = {
    state: 'system.syssetting.taxCertificate',
    config: {
        url: '/taxCertificate',
        template: '<div ui-view></div>',
        abstract: true,
        default: 'system.syssetting.taxCertificate.list',
        title: '纳税人管理',
    },
}

// 纳税人管理列表
export const taxCertificateListRouter = {
    state: 'system.syssetting.taxCertificate.list',
    config: {
        url: '/list',
        template: taxCertificatePage,
        controller: 'taxCertificateCtrl',

    },
}


// 纳税人管理新增
export const addTaxCertificateRouter = {
    state: 'system.syssetting.taxCertificate.addTaxCertificate',
    config: {
        url: '/addTaxCertificate',
        template: taxCertificateEditPage,
        controller: 'taxCertificateEditCtrl',
        title: '新增',
    },
}

// 纳税人管理编辑
export const taxCertificateEditRouter = {
    state: 'system.syssetting.taxCertificate.taxCertificateEdit',
    config: {
        url: '/taxCertificateEdit/:saleId',
        template: taxCertificateEditPage,
        controller: 'taxCertificateEditCtrl',
        title: '编辑',
    },
}



// WEBPACK FOOTER //
// ./src/app/system/systemsetting/taxcertificate/routers.js